const BuildersFrameSVG = () => {
    return (
        <svg width='400' height='280' viewBox='0 0 400 280' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fill='#fff' d='M50 40h300v200H50z' />
            <g clipPath='url(#clip0)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M271.272 129.2l17.737-2.168 13.378 108.477-17.737 2.168L271.272 129.2z'
                    fill='#CED8E1'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M280.001 200.068l17.737-2.168 3.578 29.011-17.737 2.168-3.578-29.011zM279.082 192.344l17.737-2.169.311 2.523-17.737 2.168-.311-2.522z'
                    fill='#F8A900'
                />
                <g opacity='.8'>
                    <g opacity='.8'>
                        <path opacity='.8' d='M129.553 134h-26.805v104h26.805V134z' fill='#51DAAF' />
                        <path
                            opacity='.301293'
                            d='M129.553 197.415h-26.805v25.365h26.805v-25.365zM129.553 191.073h-26.805v3.805h26.805v-3.805zM129.553 184.732h-26.805v3.805h26.805v-3.805z'
                            fill='#000'
                        />
                    </g>
                    <g opacity='.8'>
                        <path opacity='.8' d='M102.748 165.707H81.0488V238h21.6992v-72.293z' fill='#5C5CE5' />
                        <path opacity='.301293' d='M102.748 213.902H81.0488v16.488h21.6992v-16.488z' fill='#000' />
                    </g>
                </g>
                <path fillRule='evenodd' clipRule='evenodd' d='M129 238h142.819V84H129v154z' fill='#7D5500' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M136.651 230.364h127.517V91.6364H136.651V230.364z'
                    fill='#583C00'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M139.201 229.091h122.416V92.9091H139.201V229.091z'
                    fill='#fff'
                />
                <mask id='a' maskUnits='userSpaceOnUse' x='202' y='162' width='41' height='41'>
                    <path
                        d='M202.418 182.628c0 10.937 8.882 19.803 19.841 19.803 10.956 0 19.839-8.866 19.839-19.803 0-10.936-8.883-19.801-19.839-19.801-10.959 0-19.841 8.865-19.841 19.801z'
                        fill='#fff'
                    />
                </mask>
                <g mask='url(#a)'>
                    <path d='M214.452 190.047l15.196-15.168' stroke='#fff' strokeWidth='.5' />
                </g>
                <mask id='b' maskUnits='userSpaceOnUse' x='202' y='162' width='41' height='41'>
                    <path
                        d='M202.418 182.628c0 10.937 8.882 19.803 19.841 19.803 10.956 0 19.839-8.866 19.839-19.803 0-10.936-8.883-19.801-19.839-19.801-10.959 0-19.841 8.865-19.841 19.801z'
                        fill='#fff'
                    />
                </mask>
                <g mask='url(#b)'>
                    <path d='M162.299 242.101l48.809-48.716' stroke='#fff' strokeWidth='.5' />
                </g>
                <mask id='c' maskUnits='userSpaceOnUse' x='202' y='162' width='41' height='41'>
                    <path
                        d='M202.418 182.628c0 10.937 8.882 19.803 19.841 19.803 10.956 0 19.839-8.866 19.839-19.803 0-10.936-8.883-19.801-19.839-19.801-10.959 0-19.841 8.865-19.841 19.801z'
                        fill='#fff'
                    />
                </mask>
                <g mask='url(#c)'>
                    <path d='M236.749 175.86l43.663-43.579' stroke='#fff' strokeWidth='.5' />
                </g>
                <mask id='d' maskUnits='userSpaceOnUse' x='202' y='162' width='41' height='41'>
                    <path
                        d='M202.418 182.628c0 10.937 8.882 19.803 19.841 19.803 10.956 0 19.839-8.866 19.839-19.803 0-10.936-8.883-19.801-19.839-19.801-10.959 0-19.841 8.865-19.841 19.801z'
                        fill='#fff'
                    />
                </mask>
                <g mask='url(#d)'>
                    <path d='M219.469 193.106l14.026-13.999' stroke='#fff' strokeWidth='.5' />
                </g>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M167.531 202.234h42.346v-5.014h-42.346v5.014z'
                    fill='#FDE0A4'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M170.402 197.22h42.346v-5.015h-42.346v5.015z'
                    fill='#FBD37F'
                />
                <mask id='e' maskUnits='userSpaceOnUse' x='194' y='192' width='19' height='6'>
                    <path d='M194.088 192.205h18.661v5.015h-18.661v-5.015z' fill='#fff' />
                </mask>
                <g mask='url(#e)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M214.901 202.234h-2.87c-9.91 0-17.943-8.018-17.943-17.908 0-9.891 8.033-17.909 17.943-17.909h2.87v35.817z'
                        fill='#F7A802'
                    />
                </g>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M171.119 192.205h42.346v-5.014h-42.346v5.014z'
                    fill='#FDE0A4'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M168.25 187.191h42.345v-5.015H168.25v5.015z'
                    fill='#FBD37F'
                />
                <mask id='f' maskUnits='userSpaceOnUse' x='192' y='182' width='19' height='6'>
                    <path d='M192.293 182.176h18.302v5.015h-18.302v-5.015z' fill='#fff' />
                </mask>
                <g mask='url(#f)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M213.107 202.234h-2.871c-9.91 0-17.943-8.018-17.943-17.908 0-9.891 8.033-17.909 17.943-17.909h2.871v35.817z'
                        fill='#F7A802'
                    />
                </g>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M172.555 182.176H214.9v-5.014h-42.345v5.014z'
                    fill='#FBD37F'
                />
                <mask id='g' maskUnits='userSpaceOnUse' x='189' y='177' width='22' height='6'>
                    <path d='M189.781 177.162h20.814v5.014h-20.814v-5.014z' fill='#fff' />
                </mask>
                <g mask='url(#g)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M210.595 202.234h-2.871c-9.909 0-17.943-8.018-17.943-17.908 0-9.891 8.034-17.909 17.943-17.909h2.871v35.817z'
                        fill='#F7A802'
                    />
                </g>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M171.119 177.162h42.346v-5.015h-42.346v5.015z'
                    fill='#FBD37F'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M169.685 172.148h48.087v-5.014h-48.087v5.014zM173.991 167.134h39.474v-5.015h-39.474v5.015zM172.555 162.119H214.9v-5.015h-42.345v5.015zM193.369 202.234h16.508v-5.014h-16.508v5.014z'
                    fill='#FBD37F'
                />
                <path
                    d='M196.241 197.22v5.015M199.112 197.22v5.015M201.982 197.22v5.015M204.853 197.22v5.015M207.724 197.22v5.015'
                    stroke='#FDE0A4'
                    strokeWidth='.96'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M170.403 197.22h15.419v-5.015h-15.419v5.015z'
                    fill='#FDE0A4'
                />
                <path
                    d='M172.555 192.206v5.014M176.145 192.206v5.014M179.733 192.206v5.014M183.321 192.206v5.014'
                    stroke='#FBD37F'
                    strokeWidth='.96'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M196.24 177.162h17.225v-5.015H196.24v5.015z'
                    fill='#0C6E8E'
                />
                <path
                    d='M189.781 167.133v5.015M186.91 167.133v5.015M184.039 167.133v5.015M181.169 167.133v5.015M178.297 167.133v5.015M175.426 167.133v5.015M172.555 167.133v5.015'
                    stroke='#FDE0A4'
                    strokeWidth='.96'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M172.555 162.119H214.9v-2.149h-42.345v2.149zM184.038 192.205h22.25v-5.014h-22.25v5.014z'
                    fill='#FBD37F'
                />
                <mask id='h' maskUnits='userSpaceOnUse' x='190' y='172' width='22' height='6'>
                    <path d='M190.401 172.147h20.814v5.015h-20.814v-5.015z' fill='#fff' />
                </mask>
                <g mask='url(#h)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M211.215 202.234h-2.871c-9.91 0-17.943-8.018-17.943-17.908 0-9.891 8.033-17.909 17.943-17.909h2.871v35.817z'
                        fill='#F7A802'
                    />
                </g>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M171.821 142.062h42.346v-5.015h-42.346v5.015z'
                    fill='#FBD37F'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M177.203 147.075h43.922v-5.014h-43.922v5.014zM171.821 152.09h39.474v-5.015h-39.474v5.015zM170.386 157.104h42.346v-5.014h-42.346v5.014z'
                    fill='#FBD37F'
                />
                <path
                    d='M179.194 147.076v-5.015M182.065 147.076v-5.015M184.935 147.076v-5.015M187.806 147.076v-5.015M190.678 147.076v-5.015M193.549 147.076v-5.015'
                    stroke='#FDE0A4'
                    strokeWidth='.96'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M170.386 154.239h42.346v-2.149h-42.346v2.149z'
                    fill='#FBD37F'
                />
                <mask id='i' maskUnits='userSpaceOnUse' x='191' y='187' width='22' height='6'>
                    <path d='M191.217 187.191h20.814v5.015h-20.814v-5.015z' fill='#fff' />
                </mask>
                <g mask='url(#i)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M212.031 202.234h-2.871c-9.91 0-17.943-8.018-17.943-17.908 0-9.891 8.033-17.909 17.943-17.909h2.871v35.817z'
                        fill='#F7A802'
                    />
                </g>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M218.131 202.234h-2.87c-9.911 0-17.943-8.018-17.943-17.908 0-9.891 8.032-17.909 17.943-17.909h2.87v35.817z'
                    fill='#F7A802'
                />
                <path d='M189.164 197.22h17.124' stroke='#9AA9B8' strokeWidth='.96' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M167.531 137.047h42.346v-5.014h-42.346v5.014z'
                    fill='#FDE0A4'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M170.403 132.033h42.346v-5.016h-42.346v5.016zM193.369 137.047h16.508v-5.014h-16.508v5.014z'
                    fill='#FBD37F'
                />
                <path
                    d='M196.241 132.033v5.014M199.112 132.033v5.014M201.982 132.033v5.014'
                    stroke='#FDE0A4'
                    strokeWidth='.96'
                />
                <mask id='j' maskUnits='userSpaceOnUse' x='172' y='127' width='2' height='6'>
                    <path d='M172.045 127.018h1.02v5.014h-1.02v-5.014z' fill='#fff' />
                </mask>
                <g mask='url(#j)'>
                    <path d='M172.555 127.018v5.014' stroke='#FDE0A4' strokeWidth='.96' />
                </g>
                <mask id='k' maskUnits='userSpaceOnUse' x='175' y='127' width='2' height='6'>
                    <path d='M175.635 127.018h1.02v5.014h-1.02v-5.014z' fill='#fff' />
                </mask>
                <g mask='url(#k)'>
                    <path d='M176.145 127.018v5.014' stroke='#FDE0A4' strokeWidth='.96' />
                </g>
                <mask id='l' maskUnits='userSpaceOnUse' x='179' y='127' width='2' height='6'>
                    <path d='M179.223 127.018h1.02v5.014h-1.02v-5.014z' fill='#fff' />
                </mask>
                <g mask='url(#l)'>
                    <path d='M179.733 127.018v5.014' stroke='#FDE0A4' strokeWidth='.96' />
                </g>
                <mask id='m' maskUnits='userSpaceOnUse' x='182' y='127' width='2' height='6'>
                    <path d='M182.811 127.018h1.02v5.014h-1.02v-5.014z' fill='#fff' />
                </mask>
                <g mask='url(#m)'>
                    <path d='M183.321 127.018v5.014' stroke='#FDE0A4' strokeWidth='.96' />
                </g>
                <path
                    d='M176.145 132.033h30.144M189.164 197.22h17.124M187.955 192.206h17.124M185.821 187.191h17.124'
                    stroke='#F7A802'
                    strokeWidth='.96'
                />
                <mask id='n' maskUnits='userSpaceOnUse' x='191' y='167' width='22' height='6'>
                    <path d='M191.217 167.133h20.814v5.014h-20.814v-5.014z' fill='#fff' />
                </mask>
                <g mask='url(#n)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M212.031 202.234h-2.871c-9.91 0-17.943-8.018-17.943-17.908 0-9.891 8.033-17.909 17.943-17.909h2.871v35.817z'
                        fill='#F7A802'
                    />
                </g>
                <path
                    d='M172.96 172.148h36.229M174.879 177.162h36.23M177.05 182.176h36.229M185.56 162.119h27.905M177.237 167.133h36.229'
                    stroke='#F7A802'
                    strokeWidth='.96'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M222.258 202.43h-3.306c-10.958 0-19.84-8.865-19.84-19.801 0-10.937 8.882-19.802 19.84-19.802h3.306v39.603z'
                    fill='#F7A802'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M242.098 182.628c0 10.937-8.883 19.802-19.84 19.802s-19.839-8.865-19.839-19.802c0-10.936 8.882-19.801 19.839-19.801 10.957 0 19.84 8.865 19.84 19.801z'
                    fill='#FBD37F'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M237.138 182.628c0 8.203-6.662 14.852-14.88 14.852s-14.88-6.649-14.88-14.852c0-8.202 6.662-14.851 14.88-14.851s14.88 6.649 14.88 14.851z'
                    fill='#F8A900'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M235.485 182.628c0 7.292-5.923 13.201-13.227 13.201-7.305 0-13.227-5.909-13.227-13.201 0-7.291 5.922-13.2 13.227-13.2 7.304 0 13.227 5.909 13.227 13.2z'
                    fill='#FEF6E5'
                />
                <path
                    d='M177.237 157.104h32.623M173.991 152.09h32.297M180.481 147.076h22.99M180.481 142.061h32.984M173.991 137.047h33.952'
                    stroke='#F7A802'
                    strokeWidth='.96'
                />
                <g opacity='.611258'>
                    <path
                        opacity='.611258'
                        d='M218.908 174.998c2.965-1.258 6.304-.335 8.198 2.048l4.746 4.576-2.05 1.458c.663 3.11-.914 6.361-3.911 7.754l-.22.097c-3.556 1.51-7.65-.12-9.144-3.64l-1.353-3.186c-1.494-3.52.178-7.597 3.734-9.107z'
                        fill='#FBCF6F'
                    />
                    <path
                        opacity='.611258'
                        d='M218.931 174.988l.224-.091c2.317-.897 4.809-.548 6.638.74l.029.021-.005.036c-.331 2.125-1.711 4.088-3.822 5.164l-.257.124-.221.098-.139.066c-.909.466-1.334 1.518-.951 2.419.263.619.841 1.014 1.491 1.093-.345 1.961-1.584 3.77-3.465 4.853-.83-.604-1.519-1.405-1.984-2.373l-.121-.268-1.293-3.047c-1.399-3.294.236-7.155 3.656-8.737l.22-.098z'
                        fill='#F6AE15'
                    />
                </g>
                <path
                    d='M258.377 193.703l5.148 1.473-1.476 5.138-5.149-1.473 1.477-5.138zm20.814-4.094l5.138 1.508-1.512 5.129-5.138-1.509 1.512-5.128zm-35.438-13.082l5.212 1.229-1.23 5.202-5.213-1.228 1.231-5.203z'
                    fill='#FA8100'
                />
                <path
                    d='M264.643 182.546c-2.368-.679-4.821.345-6.044 2.346l-3.194 3.964 1.693.92c-.219 2.432 1.263 4.76 3.65 5.551l.211.065c2.844.815 5.808-.825 6.622-3.662l.737-2.57c.814-2.837-.832-5.799-3.675-6.614z'
                    fill='#FA8100'
                />
                <path
                    d='M258.143 189.023c-1.422-.408-2.904.412-3.311 1.831l5.148 1.476c.407-1.419-.416-2.899-1.837-3.307zm7.909-3.293c-2.133-.611-4.191.043-4.598 1.462-.148.515-.058 1.06.219 1.575.37-.306.879-.43 1.375-.287.8.229 1.262 1.062 1.034 1.86-.032.111-.076.215-.129.312.199.081.408.154.625.216 1.214.348 2.403.286 3.278-.093l.462-1.615c.189-.658.245-1.322.185-1.965l.106.122c-.564-.688-1.464-1.273-2.557-1.587z'
                    fill='#0C6E8E'
                />
                <path
                    d='M251.605 201.737c-11.092-1.436-6.458-19.867-6.458-19.867M268.227 204.029c19.456 5.377 10.236-4.723 12.232-9.961'
                    stroke='#0C6E8E'
                    strokeWidth='6.3'
                    strokeLinejoin='round'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M258.936 209.399l1.986 28.591H272l-2.423-30.735-10.641 2.144z'
                    fill='#EC6C00'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M250.315 209.633l-7.827 28.357h10.816l7.632-26.965-10.621-1.392z'
                    fill='#EC6C00'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M250.315 209.634l18.564 2.594 1.857-13.234-18.564-2.595-1.857 13.235z'
                    fill='#EC6C00'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M244.505 230.684h10.866l.757-2.672h-10.886l-.737 2.672zM260.416 230.684h11.008l-.211-2.672h-10.984l.187 2.672zM251.013 204.661l18.564 2.594.371-2.647-18.564-2.594-.371 2.647zM269.98 187.722c.163-2.029.133-5.933-6.496-8.126l-.409 1.232c-1.998.159-3.836 1.257-4.919 2.981l-2.522.779 1.857.614 6.094 2.016 6.094 2.017 1.857.614-1.556-2.127z'
                    fill='#F8A900'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M254.06 235.317l-.756 2.673h-12.756l2.678-2.673h10.834zM271.789 235.317l.211 2.673h-13.942l2.678-2.673h11.053z'
                    fill='#371F38'
                />
                <path
                    d='M237.18 170.777l-3.943 10.501c-.435 1.16.154 2.452 1.316 2.887 1.162.435 2.457-.153 2.893-1.313l1.577-4.2c.435-1.16 1.73-1.748 2.893-1.314l50.502 18.892'
                    stroke='#371F38'
                    strokeWidth='1.17483'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M239.284 171.564l-4.208-1.574-3.943 10.501 4.209 1.574 3.942-10.501z'
                    fill='#FDC180'
                />
                <path
                    d='M144.417 216.034l2.678 4.629-4.638 2.672-2.678-4.629 4.638-2.672zm-30.672 0l4.638 2.672-2.678 4.629-4.638-2.672 2.678-4.629zm17.333-21.689l2.514 4.72-4.729 2.51-2.514-4.72 4.729-2.51z'
                    fill='#FA8100'
                />
                <path d='M133.167 202.112l8.964 15.517' stroke='#0C6E8E' strokeWidth='6.3' strokeLinejoin='round' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M126.944 211.409v26.785h13.389l-2.677-2.673v-24.112h-10.712z'
                    fill='#EC6C00'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M137.656 235.521h-10.712v2.673h13.389l-2.677-2.673z'
                    fill='#371F38'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M118.911 211.409v26.843H132.3l-2.678-2.673v-24.17h-10.711z'
                    fill='#EC6C00'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M129.622 235.521h-10.711v2.673H132.3l-2.678-2.673z'
                    fill='#371F38'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M118.911 230.888h18.738v-2.672h-18.738v2.672z'
                    fill='#F8A900'
                />
                <path d='M132.263 235.521v-24.054' stroke='#371F38' strokeWidth='.933333' />
                <path
                    d='M122.903 185.515c2.176-1.157 4.788-.665 6.401 1.038l3.948 3.214-1.465 1.251c.72 2.334-.246 4.92-2.417 6.189l-.193.107c-2.611 1.389-5.852.402-7.238-2.205l-1.255-2.36c-1.386-2.606-.392-5.845 2.219-7.234z'
                    fill='#FA8100'
                />
                <path
                    d='M120.974 204.703l-4.391-8.26c-2.426-4.561-.687-10.229 3.883-12.659 4.571-2.43 10.242-.702 12.668 3.859l1.882 3.54c1.386 2.607.392 5.846-2.22 7.234l-1.59-2.991c.763-1.222 1.017-2.725.652-4.156l-.071-.252 1.465-1.251-3.948-3.214c-.336-.354-.715-.656-1.123-.901l-.005.081c-.111 1.637-.975 3.191-2.428 4.133l-.212.13-.193.108.105.207c.091.191.17.386.237.583-.106.028-.209.068-.309.122-.735.39-1.015 1.301-.625 2.034.274.516.807.806 1.354.797.955.316 1.753.986 2.226 1.876l2.101 3.951-9.458 5.029z'
                    fill='#BB5602'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M118.911 211.57h18.744V198.8h-18.744v12.77z'
                    fill='#EC6C00'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M118.911 207.458h18.747v-2.673h-18.747v2.673z'
                    fill='#F8A900'
                />
                <path d='M116.031 217.629l8.798-15.516' stroke='#0C6E8E' strokeWidth='6.3' strokeLinejoin='round' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M119.259 191.309c-.3-2.013-.534-5.91 5.932-8.545l.491 1.202c2.004.024 3.912.995 5.11 2.642l2.568.607-1.811.738-5.944 2.423-5.943 2.422-1.812.739 1.409-2.228z'
                    fill='#F8A900'
                />
                <path d='M220.427 215.142l7.557 17.601' stroke='#CED8E1' strokeWidth='1.31707' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M222.946 237.771h10.077v-12.572h-10.077v12.572z'
                    fill='#0C6E8E'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M225.465 225.199h-2.519v6.286c0 .695.564 1.258 1.259 1.258.696 0 1.26-.563 1.26-1.258 0-.694.564-1.257 1.26-1.257.695 0 1.259-.563 1.259-1.257v-3.772h-2.519z'
                    fill='#FDC180'
                />
                <path d='M222.946 225.199h10.077' stroke='#FDC180' strokeWidth='1.31707' strokeLinecap='square' />
                <path d='M230.504 227.234l5.038 5.029' stroke='#371F38' strokeWidth='1.31707' />
                <path d='M50 238h300v2H50v-2z' fill='#CED8E1' />
            </g>
            <defs>
                <clipPath id='clip0'>
                    <path fill='#fff' transform='translate(50 40)' d='M0 0h300v200H0z' />
                </clipPath>
            </defs>
        </svg>
    );
};

export default BuildersFrameSVG;
